import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { IonSegment } from '@ionic/angular';
import { IGroupers } from '../../../../private/shared/models/productos';
import { listAnimation } from './../../../../../assets/animations';

@Component({
  selector: 'getm-subcategory-item',
  templateUrl: './subcategory-item.component.html',
  styleUrls: ['./subcategory-item.component.scss'],
  animations: [listAnimation]
})
export class SubcategoryItemComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @ViewChild(IonSegment, { read: ElementRef }) segment!: ElementRef;

  @Input() agrupadores: IGroupers[] = [];
  @Input() selected: string = '';
  @Input() activeAgrupador: string | null = null;

  @Output() selectGrouper = new EventEmitter<string | null>();

  public isDesktop: boolean = false;

  // Mouse drag state
  private isDown = false;
  private startX = 0;
  private scrollLeft = 0;

  constructor() { }

  ngOnInit() {
    this.isDesktop = !Capacitor.isNativePlatform();
  }

  ngAfterViewInit(): void {
    if (!this.isDesktop) return;

    //solo en Desktop, simular swipe con click y arrastrar y ocultar el scroll
    const segmentElement = this.segment.nativeElement;
    segmentElement.addEventListener(
      'mousedown',
      this.mouseDownListener
    );

    segmentElement.addEventListener(
      'mouseleave',
      this.mouseLeaveListener
    );

    segmentElement.addEventListener(
      'mouseup',
      this.mouseUpListener
    );

    segmentElement.addEventListener(
      'mousemove',
      this.mouseMoveListener
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['activeAgrupador']) {
      const newActiveAgrupador = changes['activeAgrupador'].currentValue;

      if (newActiveAgrupador === null) {
        this.selected = null;
        setTimeout(() => {
          this.segment.nativeElement.value = '';
        });
      }
    }
  }

  ngOnDestroy(): void {
    const segmentElement = this.segment.nativeElement;
    if (segmentElement) {
      segmentElement.removeEventListener('mousedown', this.mouseDownListener);
      segmentElement.removeEventListener('mouseleave', this.mouseLeaveListener);
      segmentElement.removeEventListener('mouseup', this.mouseUpListener);
      segmentElement.removeEventListener('mousemove', this.mouseMoveListener);
    }
  }

  public onAgrupadorClick = (id: string): void => {
    if (this.selected === id) {
      this.selected = null;
      setTimeout(() => {
        this.segment.nativeElement.value = '';
      });
    } else {
      this.selected = id;
      this.segment.nativeElement.value = id;
    }
    this.selectGrouper.emit(this.selected);
  };

  public trackByGroupers = (_index: number, item: IGroupers): string =>
    item.ID_Agrupador_GETM;

  //event listeners
  private mouseDownListener = (e: MouseEvent) => {
    const segmentElement = this.segment.nativeElement;
    this.isDown = true;
    this.startX = e.pageX - segmentElement.offsetLeft;
    this.scrollLeft = segmentElement.scrollLeft;
    segmentElement.style.cursor = 'grabbing';
  };

  private mouseLeaveListener = () => {
    const segmentElement = this.segment.nativeElement;
    this.isDown = false;
    segmentElement.style.cursor = 'grab';
  };

  private mouseUpListener = () => {
    const segmentElement = this.segment.nativeElement;
    this.isDown = false;
    segmentElement.style.cursor = 'grab';
  };

  private mouseMoveListener = (e: MouseEvent) => {
    if (!this.isDown) return;
    const segmentElement = this.segment.nativeElement;
    e.preventDefault();
    const x = e.pageX - segmentElement.offsetLeft;
    const walk = (x - this.startX) * 1.5; // adjust sensitivity
    segmentElement.scrollLeft = this.scrollLeft - walk;
  };
}
